<template>
  <v-card>
    <v-card-title>
      <v-icon left>mdi-information</v-icon>
      Batch Info
      <v-spacer />
      <BatchForm :workid="batch.workorder_id" :is-edit="true" :is-duplicate="false" :instance="batch">
        <template #button="{ on }">
          <v-btn v-on="on" outlined rounded color="primary">
            <v-icon left>edit</v-icon>
            Edit
          </v-btn>
        </template>
        <template #title>
          Edit {{ batch.forgeID }}
        </template>
      </BatchForm>
    </v-card-title>
    <v-list>
      <v-subheader>Physical</v-subheader>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>{{ batch.location.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ batch.location.name }}</v-list-item-title>
          <v-list-item-subtitle>Location / Storage</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>{{ batch.coatedcyclesIcon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ batch.coatedcycles }}</v-list-item-title>
          <v-list-item-subtitle>Total Cycles</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>{{ batch.coatedquantityIcon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ batch.coatedquantity }} {{ batch.units }}</v-list-item-title>
          <v-list-item-subtitle>Total Quantity</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-subheader>Parent / Children</v-subheader>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-source-branch</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-if="batch.parent_id">{{ batch.parent.forgeID }}</v-list-item-title>
          <v-list-item-title v-else>No Parent</v-list-item-title>
          <v-list-item-subtitle>Parent Batch</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <template v-for="item in batch.children">
        <v-list-item :key="item.id">
          <v-list-item-icon>
            <v-icon>mdi-source-merge</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.forgeID}}</v-list-item-title>
            <v-list-item-subtitle>Split Batch</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import BatchForm from "./BatchForm";
export default {
  name: "BatchInfoCard",
  components: { BatchForm },
  props: {
    batch: {
      type: Object,
      required: true
    }
  }
}
</script>
